<footer class="footer" style="position: absolute; width: -webkit-fill-available;">
  <div class="container-fluid">
    <div class="row">
      <nav class="footer-nav">
        <ul>
          <li><a href="javascript:;" target="_blank">Prometheus</a></li>
          <li><a href="javascript:;" target="_blank">Blog</a></li>
          <li><a href="javascript:;" target="_blank">Licenses</a></li>
        </ul>
      </nav>
      <div class="credits ml-auto">
        <span class="copyright">
          © 2020
        </span>
      </div>
    </div>
  </div>
</footer>
